// extracted by mini-css-extract-plugin
export default {"root":"styles_root__mx+ye","red":"styles_red__Dz46v"};